import {EntityType} from "@ots-frontend/ots-data";
import {ReactElement, useMemo} from "react";
import {
  IconBuilding,
  IconChartDots3,
  IconGauge,
  IconRoute,
  IconRoute2,
  IconSitemap, IconTruck, IconUser,
  TablerIconsProps
} from "@tabler/icons-react";

export type EntityIconProps = TablerIconsProps & {
  entityType: EntityType | string
}

type Icon = {
  icon: (props: TablerIconsProps) => ReactElement
}

export const EntityIcon = (props: EntityIconProps) => {
  const {entityType, ...rest} = props

  const icon: Icon | undefined = useMemo(() => {
    if (entityType === 'COMPANY') {
      return {
        icon: IconBuilding
      }
    } else if (entityType === 'PIPE') {
      return {
        icon: IconChartDots3
      }
    } else if (entityType === 'ROUTEGROUP') {
      return {
        icon: IconRoute
      }
    } else if (entityType === 'ROUTE') {
      return {
        icon: IconRoute2
      }
    } else if (entityType === 'SITE') {
      return {
        icon: IconSitemap
      }
    } else if (entityType === 'METER') {
      return {
        icon: IconGauge
      }
    } else if (entityType === 'VEHICLE') {
      return {
        icon: IconTruck
      }
    } else if (entityType === 'TRAILER') {
      return {
        icon: IconTruck
      }
    } else if (entityType === 'PERSON') {
      return {
        icon: IconUser
      }
    } else {
      return undefined
    }
  }, [entityType])

  if (icon) {
    return (
      <icon.icon {...rest} />
    )
  } else {
    return (
      <></>
    )
  }
}
